module.exports = __webpack_public_path__ + "img/linnworks_logo.51582bc8.png";